import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateBrandingSettingsQueries } from './useBrandingSettingsQuery';

export function useApplyAdminLogoMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (brandingSettings: Api.BrandingSettings) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async ({ impersonationContext }: { impersonationContext?: Api.IImpersonationContext } = {}) => {
			// Server copies account.preferences.logo into a new, independent brand-logo attachment.
			const result = await userSession.webServiceHelper.callAsync<Api.BrandingSettings>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'accountProfile/branding/logo/apply-admin-logo',
					impersonationContext,
				}),
				'POST'
			);
			return result;
		},
		onError,
		onSuccess: (data, variables) => {
			invalidateBrandingSettingsQueries({ impersonationContext: variables?.impersonationContext });
			onSuccess?.(data);
		},
	});
}
